import React from "react";

const PeriodBadge = ({ rapport, t }) => {
  const getPeriodValue = () => {
    return (
      rapport?.period || (rapport?.period_tag && rapport.period_tag.label) || ""
    );
  };

  const period = getPeriodValue();

  const periodConfigs = {
    biannual: {
      className: "kt-badge kt-badge--inline kt-badge--info h2",
      label: t("Semestriel"),
    },
    weeks: {
      className: "kt-badge kt-badge--inline kt-badge--success h2",
      label: t("Hebdomadaire"),
    },
    quarterly: {
      className: "kt-badge kt-badge--inline kt-badge--dark h2",
      label: t("Trimestriel"),
    },
    months: {
      className: "kt-badge kt-badge--inline kt-badge--danger h2",
      label: t("Mensuel"),
    },
    default: {
      className: "kt-badge kt-badge--inline kt-badge--warning h2",
      label: t("Journalier"),
    },
  };

  const config = periodConfigs[period] || periodConfigs.default;

  return (
    <td className="text-center">
      <span className={config.className}>{config.label}</span>
    </td>
  );
};

export default PeriodBadge;
